module.exports = __webpack_public_path__ + "media/images/views/home/banner/banner-pc-2e067d9ed751f77fd896dbaaa0f032b4.png";